var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHabitsSleep = function SvgHabitsSleep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4e7ab5",
    strokeMiterlimit: 10,
    d: "M33 1.5h5.5V2l-5 6v.5H39m-13-2h4.5V7l-4 4v.5H31m-12-1h3.5v.5l-3 3v.5H23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce85",
    d: "M34.5 38.5v-3h-29v3h-4v-24c0-1.103.897-2 2-2s2 .897 2 2v17h33v7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#967a44",
    d: "M3.5 13c.827 0 1.5.673 1.5 1.5V32h33v6h-3v-3H5v3H2V14.5c0-.827.673-1.5 1.5-1.5m0-1A2.5 2.5 0 0 0 1 14.5V39h5v-3h28v3h5v-8H6V14.5A2.5 2.5 0 0 0 3.5 12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dbf2ff",
    d: "M5.5 28.5h33v3h-33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#66798f",
    d: "M38 29v2H6v-2zm1-1H5v4h34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb7f0",
    d: "M14.5 31.5v-11H32c3.584 0 6.5 2.916 6.5 6.5v4.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4e7ab5",
    d: "M32 21c3.308 0 6 2.692 6 6v4H15V21zm0-1H14v12h25v-5a7 7 0 0 0-7-7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeea3",
    d: "M10 20.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ba9b48",
    d: "M10 21c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-1a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
  })));
};
export default SvgHabitsSleep;